import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { URL } from '../../constants/url'
import Loading from '../../components/common/Loading'

import {
  createGoogleLink,
} from '../../../states/containers/auth/googleSyncSlice'

const LoginGoogleZendeskCallback: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    const urlStr = location.href
    const callbackUrl = { callback_url: urlStr }
    dispatch(createGoogleLink(callbackUrl,
      () => {
        history.push(`${URL.LOGIN.path}?zendesk=true&hidden=true`)
      },
      () => {
        history.push(`${URL.LOGIN.path}?deny_sso=true`)
      }))
  }, [location.href])

  return (
    <>
      <Loading />
    </>
  )
}

export default LoginGoogleZendeskCallback
